// @ts-nocheck

import PropTypes from 'prop-types';
import * as React from 'react';
import Link from '../../common/components/core/Link';
import { ImageService } from '../../main/services/ImageService/ImageService';
type Props = {};

class ScreenLinkExpired extends React.Component<Props> {
  render() {
    return (
      <div className="link-exipred-background">
        <div className="link-expired">
          <div className="expired-logo">
            <img src={ImageService.getImageUrl('/static/images/branch-logos/branch-logo_dark.svg')} />
          </div>
          <div className="loggedout-link-expired-container">
            <div className="loggedout--link-expired-header">Link has expired!</div>
            <img className="link-expired-image" src={ImageService.getImageUrl('/static/images/link_expired.svg')} />
            <div className="loggedout--link-expired-text-block">This link has expired, please reset password again.</div>
            <Link to="/reset" testid="link-send-reset-email" className="link-expired-btn">
              Reset Password
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ScreenLinkExpired.contextTypes = {
  router: PropTypes.object,
};
export default ScreenLinkExpired;
